@mixin create-badge-classes($name, $color) {
  .#{$name} {
    background-color: $color;
  }

  .#{$name}Inverted {
    border: 2px solid $color;
    color: $color;

    &.compact > span {
      font-weight: 700;
    }
  }
}

.badge {
  display: inline-flex;
  align-items: center;
  color: rgb(var(--colour-text-and-icon-5));
  min-width: 1rem;
  height: 1.25rem;
  padding: 0 0.25rem;

  .icon {
    background-color: transparent;
    height: inherit;
    width: auto;
  }

  .label {
    background-color: transparent;
    display: inline-block;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.01rem;
    line-height: 1;
    white-space: pre;
  }

  > .icon + .label {
    margin-left: var(--spacing-small);
  }
}

.badges {
  display: flex;

  &.compact > .order {
    margin-right: var(--spacing-small);
  }

  &:not(.compact) > .order + .order {
    margin-left: var(--spacing-medium);
  }
}

@include create-badge-classes("deleted", rgb(var(--colour-semantic-negative)));
@include create-badge-classes("moved", rgb(var(--colour-semantic-positive)));
@include create-badge-classes("publish", rgb(var(--colour-semantic-informative)));
@include create-badge-classes("summary", rgb(var(--colour-neutral-6)));
@include create-badge-classes("translation", rgb(var(--colour-commercial-message-new)));
@include create-badge-classes("autocategorized",  rgb(var(--colour-semantic-informative)));
@include create-badge-classes("invalidimage",  rgb(var(--colour-commercial-message-new)));
@include create-badge-classes("categorytypemissing",  rgb(var(--colour-commercial-message-new)));
@include create-badge-classes("categorytype",  rgb(var(--colour-semantic-informative)));
@include create-badge-classes("submitted", rgb(var(--colour-text-and-icon-3)));
@include create-badge-classes("pending", rgb(var(--colour-text-and-icon-2)));
@include create-badge-classes("approvedadjustment", rgb(245, 174, 102));
@include create-badge-classes("approved", rgb(181, 244, 147));
@include create-badge-classes("implemented", rgb(149, 235, 103));
@include create-badge-classes("notapproved", rgb(240, 128, 128));


.movedInverted.dashed {
  background-color: #0a8a001a;
  border-style: dashed;
}
